<template>
  <button 
          type="button" 
          :id="inputButton.id" 
          :class="buttonClass()"
          @click="$emit('changeButton', inputButton.value)"><span>{{ inputButton.label }}</span></button>
</template>


<script>

export default {
  name: 'custom-button-input',
  props: {
    buttonSelected: 0,
    inputButton: {
        type: Object,
        default: function () {
          return {
            id: 'buttonDefault',
            class: 'button-input-default',
            name: 'buttonDefault',
            label: 'Button',
            style: 'button',
            value: ''
          }
        }
      }
  },
  methods: {
    buttonClass: function() {
        var result = [];
        result.push('btn');
        result.push(this.inputButton.class);
        if(this.buttonSelected===this.inputButton.value)
          result.push('btn-selected');
        if(this.inputButton.style=='radio')
          result.push('btn-radio');
        return result;
    }
  },
  computed: {
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    }
  }
}
</script>

<style>
.btn{
  position: relative;

  /*width:100%;
  margin: 10px 0;
  background: #E7E7E7;*/
  
  border-radius: 0;
  line-height: 0;
  margin-right:20px;
  /*padding:5px;*/
}

.btn:hover{
  /*background: #EAEAEA;*/
  cursor: pointer;
}

.btn.btn-selected{
  /*
  background: rgb(71, 210, 145);
  color: #FFF;*/
}

.btn.btn-radio:after{
  content: "";
  display: block;
  border-radius: 30px;
  width: 30px;
  height: 30px;
  background: #FFF;
  border: 3px solid #FFF;
  border: 0 none;
  position: absolute;
  top: 50%;
    left: 10px;
    margin-top: -15px;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0,0,0,0.5);
-moz-box-shadow: inset 0px 1px 3px 0px rgba(0,0,0,0.5);
box-shadow: inset 0px 1px 3px 0px rgba(0,0,0,0.5);
}

.btn.btn-radio.btn-selected:after{  
  /*background: #29AAE5;*/
  /*border: 4px solid #FFF;*/
  
}

.btn.btn-radio:before{
  display:none;
  content: "";
  z-index: 999;
  border-radius: 22px;
  width: 22px;
  height: 22px;
  background: #29AAE5;
  border: 0 none;
  position: absolute;
  top: 50%;
    left: 14px;
    margin-top: -11px;
  
} 

.btn.btn-radio.btn-selected:before{  
  display: block;
}

.btn span{
  display: block;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 1;
}

.btn.btn-radio span{
   padding-left: 42px;
}
</style>

